import { defineMessages } from 'react-intl';

export default defineMessages({
    virtualAgentClearConversationButton: {
        defaultMessage: 'Clear conversation',
        description: 'Button text to open clear conversation modal',
        id: 'virtual-agent.clear-conversation.button.label.nonFinal',
    },
});
